module.exports = __webpack_public_path__ + "media/feature-icons/dispatch-b355e217.png";